import { render, staticRenderFns } from "./AddMemberPanel.vue?vue&type=template&id=1638c823&scoped=true"
import script from "./AddMemberPanel.vue?vue&type=script&lang=js"
export * from "./AddMemberPanel.vue?vue&type=script&lang=js"
import style0 from "./AddMemberPanel.vue?vue&type=style&index=0&id=1638c823&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1638c823",
  null
  
)

export default component.exports